$(".prices-search-form-btns").find("input[type='button']").click(function(){
    $index = $(this).index();
    $elem = $(this);
    $(".prices-search-form-btns").find("input[type='button']").each(function(){
        if($(this).index() == $index){
            $(this).addClass("btn-active");
        }
        else{
            $(this).removeClass("btn-active");
        }
    });


    $('#price_search').find("input[type='submit']").click();
});

$("#price_search").on("submit", function(e){
    if ($(this).attr("action")) {

        $path = $(this).attr("action");
        $text = $(this).find("input[name='search']").val();
        $parent = $(".prices-search-form-btns").find(".btn-active").attr("data-group");


        app.request({
            url: $path,
            method: 'GET',
            dataType: 'html',
            data: "?search=1&search_text="+$text+"&parent="+$parent,
            success: function (data) {
                $("#prices-table-data").html(data);
            }
        });
    }
    e.preventDefault();
});

